"use client"

import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { useCities } from "@/hooks/useCities"
import { Search, Loader2 } from "lucide-react"

interface FilterState {
  city: string
  priceSort: string
  searchText: string
}

interface PropertyFiltersProps {
  filters: FilterState
  onFiltersChange: (filters: FilterState) => void
}

export function PropertyFilters({ filters, onFiltersChange }: PropertyFiltersProps) {
  const { cities, loading: citiesLoading } = useCities()

  const handleFilterChange = (key: keyof FilterState, value: string) => {
    onFiltersChange({
      ...filters,
      [key]: value,
    })
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Search Input */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <Input
            placeholder="Buscar por nombre..."
            value={filters.searchText}
            onChange={(e) => handleFilterChange("searchText", e.target.value)}
            className="pl-10 h-12 border-gray-300 focus:border-raime-golden-brown focus:ring-raime-golden-brown"
          />
        </div>

        {/* City Filter */}
        <Select value={filters.city} onValueChange={(value) => handleFilterChange("city", value)}>
          <SelectTrigger className="h-12 border-gray-300 focus:border-raime-golden-brown focus:ring-raime-golden-brown">
            <SelectValue placeholder="Selecciona una ciudad" />
          </SelectTrigger>
          <SelectContent>
            {citiesLoading ? (
              <SelectItem value="loading" disabled>
                <div className="flex items-center">
                  <Loader2 className="h-4 w-4 animate-spin mr-2" />
                  Cargando...
                </div>
              </SelectItem>
            ) : (
              cities.map((city) => (
                <SelectItem key={city.id} value={city.name}>
                  {city.name}
                </SelectItem>
              ))
            )}
          </SelectContent>
        </Select>

        {/* Price Sort */}
        <Select value={filters.priceSort} onValueChange={(value) => handleFilterChange("priceSort", value)}>
          <SelectTrigger className="h-12 border-gray-300 focus:border-raime-golden-brown focus:ring-raime-golden-brown">
            <SelectValue placeholder="Ordenar por precio" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Sin ordenar</SelectItem>
            <SelectItem value="low-to-high">Precio: Menor a Mayor</SelectItem>
            <SelectItem value="high-to-low">Precio: Mayor a Menor</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
